import "./styles.css";
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuthContext } from "../../context/authContext";
import AuthGuard from "../AuthGuard";
import { ETipoPermissao } from "../../Enum/Enum";
import api from "../../Services/api";
import Logo from "../../Imagens/logoPentagov.jpg";
import { BsFillPersonVcardFill } from "react-icons/bs";
import { AiFillProfile } from "react-icons/ai";
import { IoIosPaper } from "react-icons/io";
import { HiBriefcase } from "react-icons/hi";
import { FaAngleDown, FaAngleUp, FaUserPlus, FaUsersCog, FaPowerOff, FaClipboardCheck } from "react-icons/fa";
import { CalendarCheck2, FileSignature, KeyRound } from "lucide-react";

const parseList = (response) => {
  const data = response?.data;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.rows)) return data.rows;
  if (Array.isArray(data?.data)) return data.data;
  return [];
};

const MenuLateral = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  const [cadastrosAberto, setCadastrosAberto] = useState(false);
  const [submenuOperador, setSubmenuOperador] = useState(false);
  const [submenuAssinatura, setSubmenuAssinatura] = useState(false);
  const [auditoriaAberto, setAuditoriaAberto] = useState(false);
  const [exibirAgenda, setExibirAgenda] = useState(false);
  const navigate = useNavigate();

  const { operador, authReady, logout } = useAuthContext();

  const toggleSubmenuOperador = () => {
    setSubmenuOperador(!submenuOperador);
  };

  const toggleSubmenuAssinatura = () => {
    setSubmenuAssinatura(!submenuAssinatura);
  };

  const canSeeAuditoria =
    operador?.permissaoPrincipal === 99 ||
    operador?.cargos?.some((c) => c.descricao === "Gerente Auditoria");

  useEffect(() => {
    if (!operador && !authReady) {
      navigate("/");
    }
  }, [operador, authReady, navigate]);

  useEffect(() => {
    if (!operador?.IDOperador) {
      setExibirAgenda(false);
      return;
    }

    let cancelled = false;

    const carregarGruposAgenda = async () => {
      try {
        const response = await api.get(`/agenda-grupos/operador/${operador.IDOperador}`);
        if (!cancelled) {
          setExibirAgenda(parseList(response).length > 0);
        }
      } catch (err) {
        console.error("Erro ao verificar grupos da agenda", err);
        if (!cancelled) setExibirAgenda(false);
      }
    };

    carregarGruposAgenda();

    return () => {
      cancelled = true;
    };
  }, [operador?.IDOperador]);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");

    const handleViewportChange = (event) => {
      const mobileView = event.matches;
      setIsMobile(mobileView);
      setIsOpen(!mobileView);
    };

    handleViewportChange(mediaQuery);

    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", handleViewportChange);
      return () => mediaQuery.removeEventListener("change", handleViewportChange);
    }

    mediaQuery.addListener(handleViewportChange);
    return () => mediaQuery.removeListener(handleViewportChange);
  }, []);

  useEffect(() => {
    if (!isMobile) {
      document.body.classList.remove("menu-mobile-open");
      return;
    }

    document.body.classList.toggle("menu-mobile-open", isOpen);

    return () => {
      document.body.classList.remove("menu-mobile-open");
    };
  }, [isMobile, isOpen]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleCadastros = () => {
    setCadastrosAberto(!cadastrosAberto);
  };

  const toggleAuditoria = () => {
    setAuditoriaAberto(!auditoriaAberto);
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleNavigate = () => {
    if (isMobile) {
      setIsOpen(false);
    }
  };

  return (
    <div className="menu-container">
      <button
        type="button"
        className={`menu-toggle ${isOpen ? "active" : ""}`}
        onClick={toggleMenu}
        aria-label={isOpen ? "Fechar menu" : "Abrir menu"}
        aria-expanded={isOpen}
      >
        <span className="menu-icon"></span>
        <span className="menu-icon"></span>
        <span className="menu-icon"></span>
      </button>

      {isMobile && isOpen && <button type="button" className="sidebar-backdrop" onClick={toggleMenu} aria-label="Fechar menu" />}

      <nav className={`sidebar ${isOpen ? "open" : ""}`}>
        <div id="logoMenu">
          <div className="sidebar-brand-card">
            <img id="imgLogo" src={Logo} alt="Logo PentaGov" />
            <div className="sidebar-brand-copy">
            </div>
          </div>
        </div>
        <ul id="listamenu">
          <li><Link to="/Menu" onClick={handleNavigate}><BsFillPersonVcardFill className="iconesMenu" />Clientes</Link></li>
          {exibirAgenda && (
            <li><Link to="/Agenda" onClick={handleNavigate}><CalendarCheck2 className="iconesMenu" />Agenda e Tarefas</Link></li>
          )}

          <AuthGuard tipoPermissao={ETipoPermissao.ADMIN}>
            <li id="lista_cadastro" onClick={toggleCadastros}>
              <AiFillProfile className="iconesMenu" />
              Cadastros {cadastrosAberto ? <FaAngleUp id="arrowSubmenus" /> : <FaAngleDown id="arrowSubmenus" />}
            </li>
            {cadastrosAberto && (
              <ul style={{ listStyle: "none", paddingLeft: "25px" }}>
                <li><Link to="/CadCargo" onClick={handleNavigate}><HiBriefcase className="iconesMenu" />Cargos</Link></li>
                <li><Link to="/CadOperador" onClick={handleNavigate}><FaUserPlus className="iconesMenu" />Operadores</Link></li>
                <li><Link to="/CadCliente" onClick={handleNavigate}><BsFillPersonVcardFill className="iconesMenu" />Clientes</Link></li>
                <li id="lista_cadastro" onClick={toggleSubmenuOperador}>
                  <FaUsersCog className="iconesMenu" />Operador x Clientes
                  {submenuOperador ? <FaAngleUp id="arrowSubmenus" /> : <FaAngleDown id="arrowSubmenus" />}
                </li>

                {submenuOperador && (
                  <ul style={{ listStyle: "none", paddingLeft: "25px" }}>
                    <li>
                      <Link to="/CadOperadorProcesso" onClick={handleNavigate}>
                        <FaUsersCog className="iconesMenu" />Por Operador
                      </Link>
                    </li>

                    <li>
                      <Link to="/CadProcessoOperador" onClick={handleNavigate}>
                        <FaUsersCog className="iconesMenu" />Por Cliente
                      </Link>
                    </li>
                  </ul>
                )}

                <li><Link to="/CadastroPlanejamento" onClick={handleNavigate}><BsFillPersonVcardFill className="iconesMenu" />Planejamento</Link></li>
                <li><Link to="/CadAgendaGrupo" onClick={handleNavigate}><CalendarCheck2 className="iconesMenu" />Grupos da Agenda</Link></li>
                <li><Link to="/ConsultaAuditoria" onClick={handleNavigate}><FaClipboardCheck className="iconesMenu" />Consulta Auditoria</Link></li>
                <li><Link to="/aprovexterno" onClick={handleNavigate}><FaUsersCog className="iconesMenu" />Aprovar Cad. Externo</Link></li>
              </ul>
            )}

            <li id="lista_cadastro" onClick={toggleSubmenuAssinatura}>
              <FileSignature className="iconesMenu" />Assinatura Digital
              {submenuAssinatura ? <FaAngleUp id="arrowSubmenus" /> : <FaAngleDown id="arrowSubmenus" />}
            </li>

            {submenuAssinatura && (
              <ul style={{ listStyle: "none", paddingLeft: "25px" }}>
                <li>
                  <Link to="/AssinaturaDigital" onClick={handleNavigate}>
                    <FileSignature className="iconesMenu" />Fila
                  </Link>
                </li>
                <li>
                  <Link to="/AssinaturaDigital/Certificado" onClick={handleNavigate}>
                    <KeyRound className="iconesMenu" />Certificado
                  </Link>
                </li>
              </ul>
            )}
          </AuthGuard>
          {canSeeAuditoria && (
            <>
              <li id="lista_cadastro" onClick={toggleAuditoria}>
                <FaClipboardCheck className="iconesMenu" />
                Auditoria {auditoriaAberto ? <FaAngleUp id="arrowSubmenus" /> : <FaAngleDown id="arrowSubmenus" />}
              </li>

              {auditoriaAberto && (
                <ul style={{ listStyle: "none", paddingLeft: "25px" }}>
                  <li><Link to="/AuditoriaQuestao" onClick={handleNavigate}><IoIosPaper className="iconesMenu" />Questoes e Grupos</Link></li>
                  <li><Link to="/AuditoriaOperadorSecao" onClick={handleNavigate}><FaUsersCog className="iconesMenu" />Operador x Secoes</Link></li>
                </ul>
              )}
            </>
          )}

          <li id="lista_cadastro" onClick={handleLogout}>
            <FaPowerOff className="iconesMenu" />Sair
          </li>
        </ul>
        <div className="sidebar-footer">
          <span>PentaGov</span>
        </div>
      </nav>
    </div>
  );
};

export default MenuLateral;
